export const getCommitteeRecommendationOptionsQuery = `query GetCommitteeRecommendationOptions($committeeId: String!) {
  getCommitteeRecommendationOptions(committeeId: $committeeId) {
    status
    options {
      key
      sort
      value
      additionalOptions
    }
    restrictionLabels
    adminReasons
    error {
      message
    }
  }
}`;
